const clientPageData = [
  { title: "일급비밀이란?", path: "/topSecret/intro" },
  { title: "회원 랜딩", path: "/memberLanding" },
  { title: "회원가입", path: "/register" },
  { title: "비밀번호 찾기", path: "/findPw" },
  { title: "비밀번호 재설정", path: "/resetPw" },
  { title: "LMS", path: "/lms" },
  { title: "멤버십 QnA", path: "/topSecret/topSecretQnA" },
  { title: "지식상점 홈", path: "/knowledgeStore/home" },
  { title: "첫 방문이라면?", path: "/knowledgeStore/firstVisit" },
  { title: "Vu:", path: "/knowledgeStore/vu" },
  { title: "지식상점 카테고리", path: "/knowledgeStore/category" },
  { title: "커리큘럼", path: "/knowledgeStore/curriculum" },
  { title: "커뮤니티 홈", path: "/community/home" },
  { title: "팔로우", path: "/community/follow" },
  { title: "커뮤니티 카테고리", path: "/community/category" },
  { title: "커뮤니티 글쓰기", path: "/community/write" },
  { title: "프로필", path: "/community/profile" },
  { title: "처음이라면?", path: "/community/firstVisit" },
  { title: "라이팅지도", path: "/crewOnly/writingGuide" },
  { title: "라이팅링크", path: "/crewOnly/writingLink" },
  { title: "자료창고", path: "/crewOnly/dataStorage" },
  { title: "내 서재", path: "/myPage/lib" },
  { title: "내 클래스", path: "/myPage/class" },
  { title: "스크랩", path: "/myPage/scrap" },
  { title: "포인트 내역", path: "/myPage/point" },
  { title: "쿠폰함", path: "/myPage/coupon" },
  { title: "구매 내역", path: "/myPage/purchase" },
  { title: "회원정보관리", path: "/myPage/setting" },
  { title: "자주 묻는 질문", path: "/myPage/faq" },
  { title: "1:1 문의하기", path: "/myPage/ask" },
  { title: "글쓰기", path: "/write" },
  { title: "결제", path: "/payment" },
  { title: "약관", path: "/terms" },
  { title: "검색", path: "/search" },
];

export default clientPageData;
